import React from 'react'

let CardFooter = ({children}) => <div className='card-footer'>{children}</div>

export default CardFooter